export function LoginRequired(adminRequired: boolean = false, redirectRoute = 'login', redirectIfNoAdminRoute = 'dashboard') {
  
  

  return function (target: Function) {
    Object.defineProperty(target, "loginRequired", {
      value: true
    });
    Object.defineProperty(target.prototype, "ionViewCanEnter", {
      value: function(): Promise<boolean> {
  
        return new Promise((resolve) => {
        
          if (this.nav === undefined) {
            const errorMsg = "@LoginRequired requires the target component to have the NavController injected as property 'nav'";
            console.error(errorMsg);
            throw new Error(errorMsg);
          }
          else if (this.authService === undefined) {
            const errorMsg = "@LoginRequired requires the target component to have the AuthService injected as property 'authService'";
            console.error(errorMsg);
            throw new Error(errorMsg);
          }
          else {
            this.authService.isLoggedIn().then((loggedIn) => {   
              
              if(!loggedIn) {
                this.nav.setRoot(redirectRoute);
                resolve();                
              }
              else if(adminRequired && !this.authService.user.admin) {
                this.nav.setRoot(redirectIfNoAdminRoute);
                resolve();    
              }
              else {
                resolve(true);
              }              
    
            })
          }
        });
      }
    });
  };

  

}



// WEBPACK FOOTER //
// ./src/decorators/login.required.ts